<div class="p-4 d-flex flex-column justify-content-center align-items-center text-center" style="height: 100%; min-height: 200px;">
  <mat-progress-spinner class="mt-5" diameter="50" mode="indeterminate" color="primary">
  </mat-progress-spinner>
  <h3 class="mt-3 mb-2">Operazione in corso...</h3>
  <p class="mb-0">Stiamo completando l'operazione, attendi prego.</p>
</div>
